module.exports = __webpack_public_path__ + "pc/img/create01.5060d56a.png";